// Single source of truth for Insights listings (home preview + /news-blogs).
export const posts = [
  {
    id: 1,
    image: "/blog-role-of-semiconductors.jpg",
    tag: "Industry",
    title: "The Role of Semiconductors in Modern Technology",
    excerpt: "Semiconductors are the invisible force powering everything from smartphones to AI systems, driving global innovation, efficiency, and economic stability.",
    date: "October 2, 2025",
    author: "Chiparama Engineering",
    link: "/blog/role-of-semiconductors-in-modern-technology",
  },
  {
    id: 2,
    image: "/blog-custom-chip-design.jpg",
    tag: "Custom silicon",
    title: "Custom Chip Design – Why Businesses Need Tailored Solutions for Automation",
    excerpt: "Custom chip design gives businesses a competitive edge by optimizing performance, boosting efficiency, and enabling AI-driven automation at scale.",
    date: "October 2, 2025",
    author: "Chiparama Engineering",
    link: "/blog/custom-chip-design-tailored-solutions-automation",
  },
  {
    id: 3,
    image: "/blog-semiconductor-automation.jpg",
    tag: "Automation",
    title: "Semiconductor Automation – How Smart Chips Transform Business Operations",
    excerpt: "Smart chips enable IoT integration, AI-driven insights, and edge computing — redefining operations across manufacturing, healthcare, logistics, and energy.",
    date: "October 2, 2025",
    author: "Chiparama Engineering",
    link: "/blog/semiconductor-automation-smart-chips-transform-business",
  },
  {
    id: 4,
    image: "/blog-semiconductor-trends.jpg",
    tag: "Trends",
    title: "Semiconductor Trends 2025 and Beyond",
    excerpt: "From 3D chip architecture and AI accelerators to green semiconductors and quantum computing — explore the trends shaping the next decade of innovation.",
    date: "October 2, 2025",
    author: "Chiparama Engineering",
    link: "/blog/semiconductor-trends-2025-and-beyond",
  },
];
